// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Component
import Line from './Line'
import LinesContainer from './LinesContainer'

export class EmbeddableCartLines extends Component {
  static displayName = 'EmbeddableCartLines'

  static propTypes = {
    lines: PropTypes.object,
    usePrices: PropTypes.bool,
    t: PropTypes.func
  }

  render () {
    const { lines, usePrices, t } = this.props

    return (
      <div className="booqable-component" style={{ display: 'none' }}>
        <div className="bq-cart-items">
          {lines.size() > 0 && (
            <table>
              <thead>
                <tr>
                  <td>{t('user.store.product')}</td>
                  <td>{t('user.store.quantity')}</td>
                  {usePrices && <td className="bq-cart-totals">{t('user.cart.total')}</td>}
                  <td />
                </tr>
              </thead>
              <tbody>
                <LinesContainer component={Line} />
              </tbody>
            </table>
          )}
          {lines.size() <= 0 &&
            <div className="bq-clean">{t('user.store.cart_empty')}</div>}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const cart = state.orm.carts.getById(state.client.cartId)
  const lines = state.orm.lines.getAll({ id: cart != null ? cart.lines : undefined })
  const usePrices = state.settings.get('store.use_prices')

  return { lines, usePrices }
}

const reduxComponent = reduxConnect(mapStateToProps, null)(EmbeddableCartLines)

export default withTranslation('user')(reduxComponent)
